import { Component } from "@angular/core";

@Component({
  selector: 'pg-solicitar-transferencia',
  templateUrl: './solicitar-transferencia.page.html',
  styleUrls: ['./solicitar-transferencia.page.scss']
})
export class SolicitarTransferenciaPage {

  constructor(){
  }
}